// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .team_members_image {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 50px;
    place-items: center;
  }
  .medical_expert_image {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 50px;
    place-items: center;
  }
  .ifcn_image_desktop,
  .public_spirited_image_desktop {
    display: none;
    margin: auto;
  }
  .ifcn_image_mobile {
    display: grid;
    place-items: center;
  }
  .ifcn_image_mobile {
    display: grid;
    place-items: center;
  }
  .ifcn_image {
    width: 200px;
  }
  .icnf_certificate {
    display: block;
    margin-bottom: 30px;
  }
  .policies_head {
    display: block;
  }
  .ifcn_container {
    width: 100%;
  }
  .fight_fake_news_container {
    width: 100%;
  }
  .icnf_certificate {
    display: block;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .what_we_check_items {
    width: 155px;
    height: 155px;
    align-items: center;
    justify-content: center;
  }
  .share_circle {
    display: none;
  }
  .fact_check_items_container {
    display: block;
    width: 100%;
  }
  .fact_check_item {
    align-items: center;
    justify-content: center;
    margin: 25px 0;
    gap: 0px;
  }
  .award_list_image {
    width: 180px;
  }
  .fight_fake_news_container {
    width: 100%;
    height: 100%;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
    height: auto;
  }
  .fight_fake_news_head {
    font-size: 15px;
    line-height: 1.5;
  }
  .fight_fake_news_hash {
    font-size: 140px;
  }

  .fight_fake_news_hash_val {
    font-size: 60px;
  }
  .figh_fake_news_button {
    height: 44px;
  }
  .figh_fake_news_note {
    font-size: 13px;
  }
  .fight_fake_news_container_mob {
    display: none;
  }
  .fact_check_description_one {
    width: 380px;
    font-size: 2vh;
  }
  .award_list_container_mob {
    background: linear-gradient(115deg, #111a42 10%, #f49d36 280%);
    color: white;
  }
  .award_list_two_img {
    height: 32vh;
  }
  .funding_container_right {
    margin-top: 0;
    margin-right: 0;
  }
  .fact_check_heading_mob {
    display: block;
    font-size: 3vw;
    font-family: "lato";
    margin-bottom: 5px;
    font-weight: 800;
    margin-left: 35px;
  }
  .fact_check_div_mob {
    align-items: center;
    justify-content: start;
  }
  .fact_check_image {
    height: 90px;
    width: 90px;
  }
  .fact_check_divs {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
  }
  .fact_check_heading_dt {
    display: none;
    font-size: 15px;
    font-family: "lato";
    margin-bottom: 5px;
    font-weight: 800;
  }
  .team_members_profile_card {
    display: grid;
    width: 100%;
    margin-bottom: 70px;
    gap: 60px;
    padding: 15px;
    grid-template-columns: 50% 50%;
  }
  .about_us_join_use_card_container {
    display: none;
  }
  .policy-container {
    padding: 10px;
  }

  .policy-container h1 {
    font-size: 1.5em;
  }

  .policy-container p,
  .policy-container li {
    font-size: 1em;
  }
  .corrections-policy h1 {
    font-size: 1.5em;
  }

  .corrections-policy p {
    font-size: 0.9em;
  }

  .corrections-policy li {
    font-size: 0.9em;
  }
  .ifcn_certificates_notes{
    display: flex;
    flex-direction: column;
    gap: 3px;
  }
  .ifcn_main_container {
    width: 100%;
  }
  .hide_about_page_in_mobile {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_768_1023/screen_768_1023_aboutus.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;EACrB;EACA;;IAEE,aAAa;IACb,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,QAAQ;EACV;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,YAAY;EACd;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,cAAc;EAChB;EACA;IACE,8DAA8D;IAC9D,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,WAAW;EACb;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["@media only screen and (min-width: 768px) and (max-width: 1023px) {\r\n  .team_members_image {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-row-gap: 50px;\r\n    place-items: center;\r\n  }\r\n  .medical_expert_image {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-row-gap: 50px;\r\n    place-items: center;\r\n  }\r\n  .ifcn_image_desktop,\r\n  .public_spirited_image_desktop {\r\n    display: none;\r\n    margin: auto;\r\n  }\r\n  .ifcn_image_mobile {\r\n    display: grid;\r\n    place-items: center;\r\n  }\r\n  .ifcn_image_mobile {\r\n    display: grid;\r\n    place-items: center;\r\n  }\r\n  .ifcn_image {\r\n    width: 200px;\r\n  }\r\n  .icnf_certificate {\r\n    display: block;\r\n    margin-bottom: 30px;\r\n  }\r\n  .policies_head {\r\n    display: block;\r\n  }\r\n  .ifcn_container {\r\n    width: 100%;\r\n  }\r\n  .fight_fake_news_container {\r\n    width: 100%;\r\n  }\r\n  .icnf_certificate {\r\n    display: block;\r\n    margin-bottom: 30px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  .what_we_check_items {\r\n    width: 155px;\r\n    height: 155px;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  .share_circle {\r\n    display: none;\r\n  }\r\n  .fact_check_items_container {\r\n    display: block;\r\n    width: 100%;\r\n  }\r\n  .fact_check_item {\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: 25px 0;\r\n    gap: 0px;\r\n  }\r\n  .award_list_image {\r\n    width: 180px;\r\n  }\r\n  .fight_fake_news_container {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    height: auto;\r\n  }\r\n  .fight_fake_news_head {\r\n    font-size: 15px;\r\n    line-height: 1.5;\r\n  }\r\n  .fight_fake_news_hash {\r\n    font-size: 140px;\r\n  }\r\n\r\n  .fight_fake_news_hash_val {\r\n    font-size: 60px;\r\n  }\r\n  .figh_fake_news_button {\r\n    height: 44px;\r\n  }\r\n  .figh_fake_news_note {\r\n    font-size: 13px;\r\n  }\r\n  .fight_fake_news_container_mob {\r\n    display: none;\r\n  }\r\n  .fact_check_description_one {\r\n    width: 380px;\r\n    font-size: 2vh;\r\n  }\r\n  .award_list_container_mob {\r\n    background: linear-gradient(115deg, #111a42 10%, #f49d36 280%);\r\n    color: white;\r\n  }\r\n  .award_list_two_img {\r\n    height: 32vh;\r\n  }\r\n  .funding_container_right {\r\n    margin-top: 0;\r\n    margin-right: 0;\r\n  }\r\n  .fact_check_heading_mob {\r\n    display: block;\r\n    font-size: 3vw;\r\n    font-family: \"lato\";\r\n    margin-bottom: 5px;\r\n    font-weight: 800;\r\n    margin-left: 35px;\r\n  }\r\n  .fact_check_div_mob {\r\n    align-items: center;\r\n    justify-content: start;\r\n  }\r\n  .fact_check_image {\r\n    height: 90px;\r\n    width: 90px;\r\n  }\r\n  .fact_check_divs {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: start;\r\n  }\r\n  .fact_check_heading_dt {\r\n    display: none;\r\n    font-size: 15px;\r\n    font-family: \"lato\";\r\n    margin-bottom: 5px;\r\n    font-weight: 800;\r\n  }\r\n  .team_members_profile_card {\r\n    display: grid;\r\n    width: 100%;\r\n    margin-bottom: 70px;\r\n    gap: 60px;\r\n    padding: 15px;\r\n    grid-template-columns: 50% 50%;\r\n  }\r\n  .about_us_join_use_card_container {\r\n    display: none;\r\n  }\r\n  .policy-container {\r\n    padding: 10px;\r\n  }\r\n\r\n  .policy-container h1 {\r\n    font-size: 1.5em;\r\n  }\r\n\r\n  .policy-container p,\r\n  .policy-container li {\r\n    font-size: 1em;\r\n  }\r\n  .corrections-policy h1 {\r\n    font-size: 1.5em;\r\n  }\r\n\r\n  .corrections-policy p {\r\n    font-size: 0.9em;\r\n  }\r\n\r\n  .corrections-policy li {\r\n    font-size: 0.9em;\r\n  }\r\n  .ifcn_certificates_notes{\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 3px;\r\n  }\r\n  .ifcn_main_container {\r\n    width: 100%;\r\n  }\r\n  .hide_about_page_in_mobile {\r\n    display: none !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
